export default __webpack_public_path__ + "static/media/evento-2.dabcf04c.jpg";